module.exports = __webpack_public_path__ + "img/gift.44957b53.svg";